import { useState, useEffect } from 'react';

/**
 * 뷰포트 너비가 bp 이하이면 true를 반환합니다.
 * 기본 breakpoint: 1080px (NavigationBar 모바일 전환 기준)
 */
export function useIsMobile(bp = 1080) {
    const [isMobile, setIsMobile] = useState(
        typeof window !== 'undefined' ? window.innerWidth <= bp : false
    );

    useEffect(() => {
        const onResize = () => setIsMobile(window.innerWidth <= bp);
        onResize();
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, [bp]);

    return isMobile;
}
